import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from 'next-themes';
import '@/App.css';
import referralService from '@/services/referralService';
import websocketService from '@/services/websocket';

// Pages
import Home from '@/pages/Home';
import Login from '@/pages/LoginNew';
import Register from '@/pages/Register';
import RegistroVendedor from '@/pages/RegistroVendedor';
import CompletarDatos from '@/pages/CompletarDatos';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import SorteoLanding from '@/pages/SorteoLanding';
import UsuarioDashboard from '@/pages/UsuarioDashboard';
import VendedorDashboard from '@/pages/VendedorDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import PerfilUsuario from '@/pages/PerfilUsuario';
import PerfilAdmin from '@/pages/PerfilAdmin';
import PagoConfirmacion from '@/pages/PagoConfirmacion';
import Gracias from '@/pages/Gracias';
import FacebookPixel from '@/components/FacebookPixel';

function App() {
  // Inicializar WebSocket y detectar vendedor desde URL al cargar la aplicación
  useEffect(() => {
    referralService.checkAndSaveFromURL();
    
    // Conectar WebSocket globalmente al iniciar la app
    websocketService.connect();

    // Seguimiento de visitas (una por sesión)
    let sessionId = sessionStorage.getItem('wishway_session_id');
    if (!sessionId) {
      sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem('wishway_session_id', sessionId);
    }
    
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    if (API_URL) {
      fetch(`${API_URL}/api/track-visita`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId })
      }).catch(err => console.error('Error tracking visit:', err));
    }
    
    return () => {
      websocketService.disconnect();
    };
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <FacebookPixel />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/registro-vendedor" element={<RegistroVendedor />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/completar-datos" element={<CompletarDatos />} />
              <Route path="/sorteo/:slug" element={<SorteoLanding />} />
              <Route path="/usuario" element={<UsuarioDashboard />} />
              <Route path="/usuario/perfil" element={<PerfilUsuario />} />
              <Route path="/vendedor" element={<VendedorDashboard />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/perfil" element={<PerfilAdmin />} />
              <Route path="/pago/confirmacion" element={<PagoConfirmacion />} />
              <Route path="/gracias" element={<Gracias />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
